import { isInvalidDateRange } from '../lib/time'

export default function DateRangeFields({ from, to, onFromChange, onToChange }) {
    const invalid = isInvalidDateRange(from, to)
    const style = { padding: '6px 10px', borderRadius: '8px', border: `1.5px solid ${invalid ? '#DC2626' : '#E5E7EB'}`, fontSize: '13px', outline: 'none' }
    return (
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
            <input type="date" aria-label="Дата начала по МСК" aria-invalid={invalid} value={from} max={to || undefined} onChange={event => onFromChange(event.target.value)} style={style} />
            <span style={{ fontSize: '13px', color: '#6B7280' }}>—</span>
            <input type="date" aria-label="Дата окончания по МСК включительно" aria-invalid={invalid} value={to} min={from || undefined} onChange={event => onToChange(event.target.value)} style={style} />
            <span style={{ fontSize: '11px', color: '#6B7280' }}>МСК</span>
            {invalid && <span role="alert" style={{ flexBasis: '100%', color: '#DC2626', fontSize: '12px' }}>Начальная дата должна быть не позже конечной</span>}
        </div>
    )
}
